import { api } from './ApiService';

export default class DashboardService {
    
    static async get(token){
        let response = await api.get(
            `/dashboard`
        )
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/DashboarService.js